<!--
	作者：masonchen
	时间：2017-04-10
	描述：轨迹回放页面
-->
<template>
	<!--车辆监控页面_右侧tab面板之车辆预警开始-->
	<div class="tab-bar">
		<div class="tab-row" style="height:calc(100% - 28px)">
			<div class="alarm_remind ">
				<!-- 切换标签打开关闭的状态 移动open的位置即可 移到那一栏 当栏展开 其他栏合并 -->
				<div class="vehicle_alarm" :class="{open:curAlarmType==1}" @click="toShowAlarm(1)">
					<vehicle-alarm-emg :emgNum="alarmEmgNum"></vehicle-alarm-emg>
				</div>
				<div class="vehicle_alarm" :class="{open:curAlarmType==2}" @click="toShowAlarm(2)">
					<vehicle-alarm-ord :ordNum="alarmEmgOrd"></vehicle-alarm-ord>
				</div>
				<div class="vehicle_alarm" :class="{open:curAlarmType==3}" @click="toShowAlarm(3)">
					<vehicle-alarm-gen :genNum="alarmEmgGen"></vehicle-alarm-gen>
				</div>
			</div>
		</div>
		<div class="track_bottom_btn">
			<i v-if="permission.indexOf('monitorVehicle_alarmPanelDetailList') == -1" @click="addTab">
				<a class="ico_02">预警一览</a>
			</i>
			<a @click="refreshAlm">刷新</a>
		</div>
	</div>
	<!--车辆监控页面_右侧tab面板之车辆预警结束-->
</template>
<script>
	import {mapState} from 'vuex'
	import VehicleAlarmEmg from 'components/pages/didivehiclemonitor/menumaptabs/VehicleAlarmEmg'
	import VehicleAlarmGen from 'components/pages/didivehiclemonitor/menumaptabs/VehicleAlarmGen'
	import VehicleAlarmOrd from 'components/pages/didivehiclemonitor/menumaptabs/VehicleAlarmOrd'
	export default {
		name: 'VehicleAlarm',
		components:{
			VehicleAlarmEmg,
			VehicleAlarmGen,
			VehicleAlarmOrd
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["monitorVehicle"]?this.$store.state.permission.permission["monitorVehicle"]:[],
				//获取预警信息参数
				param:{
					almLevel:1,
					planOwnerType:1,
					page_index:1
				},
				alarmEmgNum:0,
				alarmEmgOrd:0,
				alarmEmgGen:0
			}
		},
		computed: mapState({
			curAlarmType:state=>state.monitor.curAlarmType, //默认展开哪个预警窗口
			alarmNum: state => state.monitor.alarmNum
		}),
		watch:{
			alarmNum(val){
				let emgI = val.findIndex(n=>n.almLevel==1)
					if(emgI!=-1){
						this.alarmEmgNum = val[emgI].msgCount
					}else{
						this.alarmEmgNum = 0
					}
					let ordI = val.findIndex(n=>n.almLevel==2)
						if(ordI!=-1){
							this.alarmEmgOrd = val[ordI].msgCount
						}else{
							this.alarmEmgOrd = 0
						}
					
					let genI = val.findIndex(n=>n.almLevel==3)
						if(genI!=-1){
							this.alarmEmgGen = val[genI].msgCount
						}else{
							this.alarmEmgGen = 0
						}
			}
		},
		beforeMount(){
			this.$store.dispatch('showAlarmInfo',this.param)
		},
		methods: {
			toShowAlarm(index){//切换显示各类预警信息
				this.param.almLevel = index;
				this.$store.dispatch('showAlarmInfo',this.param)
			},
			addTab(){
				const obj = {
					name:'车辆预警一览',
					id:'PageAlarmHandleList',
					route:'/indexhome/alarmHandleList',
					No:'alarmHandleList'
				}
				this.$router.push('/indexhome/alarmHandleList');
				this.$store.dispatch('addTab',obj);
			},
			refreshAlm(){
				this.param.almLevel = this.curAlarmType
				this.$store.dispatch('showAlarmInfo',this.param)
				this.$store.dispatch('getAlarmNum')
			}
		}

	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// VehicleAlarm.vue?89041efa